export default __webpack_public_path__ + "static/media/single-rope-border-none.29a3f2a7.svg";